import React, { Component } from "react";
import { Submissions } from "$components/project/index";
import { getSubmissions } from "../../api";
import { showAlert } from "$actions/root";
import { createReport, createReportForReporters } from "$actions/submissions";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import isEqual from "lodash/isEqual";
import { currentAgentSelector } from "$selectors";

@connect(
  (state) => ({
    agent: currentAgentSelector(state),
  }),
  { showAlert, createReport, createReportForReporters }
)
export default class ListRoute extends Component {
  state = {
    submissions: [],
    fetching: true,
  };

  async loadData(props) {
    const { id: projectId } = (props || this.props).params;
    const { query } = (props || this.props).location;

    const {
      data: submissions,
      meta: { total_count: totalCount },
    } = await getSubmissions(projectId, query.page, query);
    this.setState({ submissions, totalCount, fetching: false });
  }

  componentWillMount() {
    this.loadData();
  }

  createReport({ type }) {
    this.props.createReport(
      this.props.params.id,
      type,
      this.props.location.query
    );
  }

  createReportForReporters({ type, selectedEmails }) {
    const reportData = {
      type: type,
      selected_emails: selectedEmails,
    };
    this.props.createReportForReporters(
      this.props.params.id,
      reportData,
      this.props.location.query
    );
  }

  componentWillReceiveProps(nextProps) {
    const { query, key } = this.props.location;
    const { query: nextQuery, key: nextKey } = nextProps.location;

    if (!isEqual(query, nextQuery) || !isEqual(key, nextKey)) {
      this.loadData(nextProps);
    }
  }

  updateFilter(key, value) {
    const query = { ...this.props.location.query };
    const { id: projectId } = this.props.params;

    query[key] = value;

    browserHistory.push({
      pathname: `/project/${projectId}/submissions`,
      query: query,
    });
  }
  get filters() {
    const filters = this.state.filters || this.props.location.query;

    Object.keys(filters).forEach((key) => {
      if (filters[key] === "true") filters[key] = true;
      else if (filters[key] === "false") filters[key] = false;
    });

    return filters;
  }

  render() {
    const { submissions, totalCount, fetching } = this.state;
    const {
      params: { id: projectId },
      location: {
        query: { page },
      },
      project,
      agent,
    } = this.props;

    return (
      <Submissions
        account={agent}
        submissions={submissions}
        project={project}
        projectId={projectId}
        currentPage={page || 1}
        totalCount={totalCount}
        onFilterChange={::this.updateFilter}
        filters={this.filters}
        createReport={::this.createReport}
        createReportForReporters={::this.createReportForReporters}
        fetching={fetching}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/submissions/list.js